import React, { useContext } from "react";

import TextField from "@mui/material/TextField";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import AmenityAvailability from "../Inputs/AmenityAvailability";
import { dateForDateInputFromState, ensureDateStringHasTime } from "../../../../Helpers/DateTimeHelper";
import BookingFormRecurrence from "../Sections/BookingFormRecurrence";
import { BookingFormContext } from "../BookingFormProvider";
import BookingConfigProvider from "../BookingConfigProvider";


const BookingFormTimeSection = (props) => {

    const {
        date,
        amenity,
        booking,
        errors,

        bookingConfig,

        onBookingFormChangeMultiple,

        onBookingDateChange,
        onBookingDateInputChangeEvent,
        onBookingIntervalChange,
        setErrorInTimeline,
    } = useContext(BookingFormContext);

    return (
        <section className="section form-container full">
            <FormRow
                label="Date" errorMessage={errors.date}
            >
                <TextField
                    type="date"
                    name="date"
                    value={dateForDateInputFromState(date)}
                    onChange={onBookingDateInputChangeEvent}
                    style={{ width: 140 }}
                />
            </FormRow>

            <FormRow
                label="Time" errorMessage={errors.start} required
            >
                {(!!bookingConfig) && (
                    <BookingConfigProvider
                        amenity={amenity}
                        unitId={booking.unit_id ?? null}
                        bookingConfig={bookingConfig}
                        bookingDate={ensureDateStringHasTime(date)}
                        onBookingDateChange={onBookingDateChange}
                    >
                        <AmenityAvailability
                            isEditingExistingBooking={!!booking.id}
                            showBookButton={false}
                            selectedInterval={{
                                start: booking.start,
                                end: booking.end
                            }}
                            onChange={(value) => onBookingIntervalChange(value)}
                            onError={(error) => {
                                setErrorInTimeline(error);
                            }}
                            startTimeErrorMessages={errors.start}
                        />
                    </BookingConfigProvider>
                )}
            </FormRow>

            <BookingFormRecurrence
                booking={booking}
                bookingConfig={bookingConfig}
                onBookingFormChange={onBookingFormChangeMultiple}
            />
        </section>
    );
};

BookingFormTimeSection.propTypes = {};

BookingFormTimeSection.defaultProps = {};

export default BookingFormTimeSection;
